import { render, staticRenderFns } from "./UserArchiveTimesheets.vue?vue&type=template&id=532e71de&scoped=true&"
import script from "./UserArchiveTimesheets.vue?vue&type=script&lang=ts&"
export * from "./UserArchiveTimesheets.vue?vue&type=script&lang=ts&"
import style0 from "./UserArchiveTimesheets.vue?vue&type=style&index=0&id=532e71de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e71de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VSelect,VTextField})
